import React, {Component} from 'react';
import countries from "../../../assets/country_codes";
import * as actions from "../../store/actions";
import connect from "react-redux/es/connect/connect";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import countryFlag from "../../../assets/countryFlag";
import {Link} from "react-router-dom";
import {arrayToDataTable} from "../../config/Utils";
import {ChartCardComponent} from "../../v2/components/chartCards/chartCard";
import {CountryStatisticsSidebarComponent} from "../../v2/components/sidebars/countryStatisticsSidebarComponent";
import Aux from "react-aux";
import {TreeMapCardComponent} from "../../v2/components/chartCards/treeMapCard";
import CountryRecentlyApproved from "../CountryRecentlyApproved/CountryRecentlyApproved";

class CountryStatistics extends Component {

    state = {
        countryCode: '',
        availableCountries: [],
        selectedCountry: 'BE',
        treeMapDataPreprocessed: [],
        // parentAndDrugGroups: null,
        atcGroupsDict: new Map()
    };

    async componentDidMount() {
        await this.setState({countryCode: this.props.match.params.countryCode});
        await this.props.onStatisticsFetch(this.props.match.params.countryCode);
        this.props.onATCCountriesCountFetch();
        this.props.onDrugsPerATC(this.state.countryCode);
    }

    chartCallback = ({chartWrapper}) => {
        let chart = chartWrapper.getChart()
        let dataTable = chartWrapper.getDataTable()
        let {row} = chart.getSelection()[0]
        let selectedAtcGroup = dataTable.getValue(row, 0);
        this.setState({
            parentAndDrugGroups: {
                parent: selectedAtcGroup,
                children: this.state.atcGroupsDict.get(selectedAtcGroup)
            }
        })
    }


    // noinspection JSCheckFunctionSignatures
    shouldComponentUpdate(nextProps, nextState) {
        /*
        * Because of the large data, the data preprocessing is done here,
        * only once, if the props change, instead of every chart render
        */

        if (nextProps.drugsPerATC && this.props.drugsPerATC !== nextProps.drugsPerATC) {
            let atcGroupMapper = new Map()
            for (const {atcCode, atcName, parent, atcLevel} of nextProps.drugsPerATC) {
                let handleNullParent = parent != null ? parent : 'Browse Drugs'
                let mapItem = atcGroupMapper.get(handleNullParent)
                if (mapItem) {
                    mapItem.push({
                        level: atcLevel,
                        atcCode: atcCode,
                        atcName: atcName
                    })
                } else {
                    atcGroupMapper.set(handleNullParent, [{
                        level: atcLevel,
                        atcCode: atcCode,
                        atcName: atcName
                    }])
                }
            }

            let treeMapData = nextProps.drugsPerATC
                .filter(drug => drug.parent !== 'Error') // NOTE: handles error cells
                .map(drug => {
                    return {
                        atcCode: drug.atcCode,
                        parent: drug.parent ? drug.parent : 'Browse Drugs',
                        drugsCount: drug.drugsCount,
                        color: 1
                    }
                })

            treeMapData = arrayToDataTable(treeMapData)
            treeMapData.push(['Browse Drugs', null, 45000, 12])
            let selectedAtcGroup = 'Browse Drugs'
            this.setState({
                treeMapDataPreprocessed: treeMapData,
                atcGroupsDict: atcGroupMapper,
                parentAndDrugGroups: {
                    parent: selectedAtcGroup,
                    children: atcGroupMapper.get(selectedAtcGroup)
                }
            })
        }

        if (nextProps.atcCountriesCount && this.props.atcCountriesCount !== nextProps.atcCountriesCount) {
            let distinctCountryCodes = new Set([...nextProps.atcCountriesCount
                .filter(c => c.countryCode != null && c.countryCode !== '')
                .map(c => c.countryCode)])

            this.setState({
                availableCountries: [...distinctCountryCodes],
                selectedCountry: distinctCountryCodes[0]
            })
        }

        return true;
    }

    renderSidePanel = () => {
        let topManufacturers = this.props.countryStatistics.drugsCountPerManufacturer
            .slice(0, 5)
            .filter(it => it.countryCode !== "")
            .map(item => [item.countryCode, item.count]);
        topManufacturers.unshift(['Manufacturer', 'Drugs count']);
        let imageName = countryFlag[this.state.countryCode.toUpperCase()];

        return (
            <Aux>
                <CountryStatisticsSidebarComponent
                    image={imageName}
                    country={countries[this.state.countryCode.toUpperCase()]}
                    drugsCount={this.props.countryStatistics.drugsCount}
                    manufacturers={topManufacturers}
                    numberOfManufacturers={this.props.countryStatistics.numberOfManufacturers}
                />
                <div className={"ibox my-0"}>
                    <div className="ibox-title">
                        <h4>See more</h4>
                    </div>
                    <div className="ibox-content">
                        <Link className={"btn btn-success btn-lg w-100"} to={{
                            pathname: '/country/compare',
                            state: {countryCode: this.state.countryCode},
                            search: '?countryCode=' + this.state.countryCode
                        }}>Compare with another country?</Link>
                    </div>
                </div>
            </Aux>
        )
    };

    render() {
        if (this.state.loading || !this.props.atcCountriesCount) {
            return <div className='d-flex align-items-center justify-content-center' style={{minHeight: '60vh'}}>
                <CircularProgress/></div>
        }
        if (!this.props.countryStatistics) {
            return (
                <div className={"d-flex align-items-center justify-content-center"}
                     style={{color: '#5c5a5d', minHeight: 80 + 'vh'}}><CircularProgress/></div>
            )
        }
        return (
            <div className={"min-vh-100"}>
                <div className={"row"}>
                    <div className={"col-4"}>
                        {this.renderSidePanel()}
                    </div>
                    <div className="col-8">
                        <TreeMapCardComponent
                            data={this.state.treeMapDataPreprocessed}
                            title={'Tree map chart'}
                            subtitle={"Lager areas indicate higher number of subgroups"}
                            height={'525px'}
                        />
                    </div>
                </div>
                <div className={"row mt-4"}>
                    <div className={"col-6"}>
                        <ChartCardComponent
                            chartType={'Bar'}
                            height={'400px'}
                            title={'Anatomical Groups'}
                            subtitle={`Drugs count for each anatomical groups(level 1) for ${countries[this.state.countryCode.toUpperCase()]}`}
                            data={arrayToDataTable(this.props.countryStatistics.anatomicalGroupsCount, ['Anatomical Group', 'Count'])}
                        />
                    </div>
                    <div className={"col-6"}>
                        <ChartCardComponent
                            chartType={'LineChart'}
                            height={'400px'}
                            title={'Licenced drugs per year'}
                            subtitle={`Number of drugs licenced per year for ${countries[this.state.countryCode.toUpperCase()]}`}
                            data={arrayToDataTable(this.props.countryStatistics.drugsPerLicenceValidFromYear, ['Year', 'Count'])}
                        />
                    </div>
                </div>
                {
                    this.state.countryCode
                    ? <CountryRecentlyApproved countryCode={this.state.countryCode}/>
                    : null
                }
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onStatisticsFetch: (country) => dispatch(actions.getStatisticsForCountry(country)),
        onATCCountriesCountFetch: () => dispatch(actions.getATCCountriesCount()),
        onDrugsPerATC: (countryCode) => dispatch(actions.getDrugsPerAtc(countryCode))
    }
};


const mapStateToProps = state => {
    return {
        countryStatistics: state.countries.statistics,
        atcCountriesCount: state.drugsStatistics.atcCountriesCount,
        drugsPerATC: state.drugsStatistics.drugsPerATC
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(CountryStatistics);
